import { render, staticRenderFns } from "./BeforeYouContinue.vue?vue&type=template&id=89a6d638&scoped=true&"
import script from "./BeforeYouContinue.vue?vue&type=script&lang=js&"
export * from "./BeforeYouContinue.vue?vue&type=script&lang=js&"
import style0 from "./BeforeYouContinue.vue?vue&type=style&index=0&id=89a6d638&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a6d638",
  null
  
)

export default component.exports